export default __webpack_public_path__ + "static/media/bar-system-connections.c9bc9239.svg";